"use strict";

/**
 * Helper method to parse mapped cookie's string value into object
 * @param {string} value - cookie value mapping. Example: attr1=value1&attr2=value2
 * @param {String} separator - separator of values str
 * @returns {Object|null} - Result object or null
 */
function parseCookieValueToObject(value, separator) {
    if (!value || !separator) {
        return null;
    }

    let resultObj = value.split(separator).reduce(function (acc, curr) {
        let pair = curr.split("=");
        acc[pair[0]] = pair[1];
        return acc;
    }, {});

    return resultObj;
}

/**
 * Helper method to get cookie object by name from request
 * @param {object} req - request object
 * @returns {Object|null} - Result object or null
 */
function getCookieObj(req, cookieName) {
    const cookies = req.getHttpCookies();
    let cookieObj = null;

    if (!cookies || !cookieName) {
        return cookieObj;
    }

    for (let i = 0; i < cookies.cookieCount; i++) {
        let cookie = cookies[i];
        if (cookie.name === cookieName) {
            cookieObj = cookie;
        }
    }

    return cookieObj;
}

/**
 * Retrieves the value of a cookie by its name.
 *
 * @param {string} name - The name of the cookie to retrieve.
 * @returns {string|undefined} The value of the cookie, or `undefined` if not found.
 */
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
}

/**
 * Sets a cookie with a specified name, value, and expiration in days.
 *
 * @param {string} name - The name of the cookie.
 * @param {string} value - The value to be stored in the cookie.
 * @param {number} days - Number of days until the cookie expires.
 */
function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value}; path=/; expires=${expires.toUTCString()}`;
}

module.exports = {
    parseCookieValueToObject,
    getCookieObj,
    getCookie,
    setCookie
};
